import { BLACK_a, BLACK_d, MAIN_GREEN } from "baseStyles";
import { MOBILE_LAYOUT_LENGTH } from "constants/UIConstants";
import styled from "styled-components";

export const MainBox = styled.div`
  height: auto;
  border-bottom: 1px solid #363636;
  padding: 4.3rem 8rem 9rem 6rem;
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    height: auto;
    padding: 4rem 0rem 5rem 20px;
  }
`;

export const MainTop = styled.div`
  display: flex;
  align-items: center;
  gap: 1.5rem;
  font-weight: 700;
  font-size: 3.2rem;
  line-height: 5.4rem;
  margin-bottom: 2.4rem;
  & > span {
    font-weight: 300;
    font-size: 2.4rem;
    line-height: 4.2rem;
    color: ${MAIN_GREEN};
    padding: 0 1rem;
    background-color: rgba(13, 96, 38, 0.1);
    border-radius: 0.5rem;
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    font-size: 2.4rem;
    line-height: 4.2rem;
    margin-bottom: 1.6rem;
    & > span {
      font-size: 2rem;
      line-height: 3.6rem;
      padding: 0.1rem 0.8rem;
    }
  }
`;

export const MainTextBox = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 5rem;

  & > span {
    font-weight: 700;
    font-size: 2.4rem;
    line-height: 4.2rem;
  }
  & > div:nth-child(2) {
    margin-top: 1rem;
    & > span {
      font-weight: 500;
      font-size: 2rem;
      line-height: 3.6rem;
    }
  }

  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    padding-right: 20px;

    & > span {
      display: flex;
      flex-direction: column;
      font-size: 1.8rem;
      line-height: 3.2rem;
      &:nth-child(1) {
        white-space: normal;
        width: 105%;
      }
    }
    & > div:nth-child(2) {
      margin-top: 2rem;
      & > span {
        font-size: 1.6rem;
        line-height: 2.8rem;
      }
    }
  }
`;
export const MainList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-left: 2rem;
  padding-top: 1.5rem;
  & > div {
    display: flex;
    gap: 0.8rem;
    & > img {
      margin-top: 1.3rem;
      width: 0.4rem;
      height: 0.4rem;
    }
    & > span {
      font-weight: 300;
      font-size: 1.8rem;
      line-height: 3.2rem;
      color: ${BLACK_d};

      & > div {
        margin-left: 2rem;
      }

      & > div:nth-child(3) {
        font-weight: 300;
        font-size: 14px;
        line-height: 24px;
        color: ${BLACK_a};
      }
    }
  }
  @media screen and (max-width: ${MOBILE_LAYOUT_LENGTH}) {
    padding-left: 1rem;
    padding-top: 2rem;
    & > div {
      gap: 1rem;
      & > span {
        font-size: 1.6rem;
        line-height: 2.8rem;
        display: flex;
        flex-direction: column;
        & > div {
          width: 29rem;
          margin-bottom: 2rem;
          margin-left: 0.5rem;
          font-size: 1.4rem;
          line-height: 2.4rem;
          & > span {
            display: flex;
            flex-direction: column;
          }
        }
      }
    }
  }
`;
